import { graphql } from "gql.tada";
import { AccessibleMediaFragment } from "@queries/fragments/AccessibleMediaFragment";

export const EventChapterFragment = graphql(`
  fragment EventChapterFragment on EventsChapter {
    __typename
    sys { id }
    title
    body
    chapterCta {
      text
      isExternal
      url
      slug
    }
    source { 
      text
    }
    carouselMediaCollection(limit: 10) {
      items {
        ...AccessibleMediaFragment
      }
    }
  }`,
  [
    AccessibleMediaFragment,
  ]
);
